import studentImg27 from '@/assets/images/courses/4by3/27.jpg'

export const cyberSecurityCourse = {
  id: 'cyber-security-01',
  title: 'Cyber Security (5 Day Training Program)',
  description: 'An intensive 5-day training program covering the essentials of cybersecurity, from foundational concepts to advanced hardware security.',
  image:studentImg27,
  studentImage: studentImg27,
  badge: {
    text: 'Advanced',
    class: 'bg-danger text-danger',
  },
  rating: {
    star: 4.8,
    review: 150,
  },
  students: 1200,
  lectures: 32,
  duration: '5 Days',
  // price: 1299,
  // originalPrice: 1599,
  // discount: 18,
  instructor: {
    name: 'Dr. Secure Coder',
    avatar: '/images/avatar/07.jpg',
    title: 'Lead Security Analyst',
    bio: 'With over 15 years of experience in the cybersecurity field, Dr. Coder is a renowned expert in ethical hacking and network defense. He has helped numerous organizations strengthen their security posture.',
  },
  category: {
    name: 'Cybersecurity',
  },
  whatYouWillLearn:[
    'Fundamentals of Cybersecurity (CIA Triad, Cryptography)',
    'Understanding of AI Security and Vulnerabilities',
    'Hands-on experience with Hardware Security attacks',
    'Knowledge of Security Standards and Defense Mechanisms',
    'Practical skills in network scanning and malware analysis',
  ],
  status: 'Live',
  label: 'Featured',
  subject: 'Cybersecurity, Hardware Security, AI Security',
  action: 'pending',
  videoUrl: 'https://www.youtube.com/embed/tXHviS-4ygo',
  curriculum: [
    {
      title: 'Day 1: Background on Cybersecurity',
      lectures: [
        { title: 'Internet-of-Things and Cyber Physical Systems (CPS): Background', time: '1h' },
        { title: 'CIA Triad & Security Objectives', time: '1h' },
        { title: 'Cryptography Primer and Cryptography', time: '1h' },
        { title: 'Protocol breakdown: TLS, End-to-End Security', time: '1h' },
        { title: 'Practical Examples: Payment Systems, Digital Signature, Blockchain', time: '1h' },
        { title: 'CPS and IoT Attack Landscape', time: '1h' },
        { title: 'Attack Example: Smart Grid, Automotive', time: '1h' },
      ],
    },
    {
      title: 'Day 2: Security of AI & AI For Security',
      lectures: [
        { title: 'Machine Learning: The Big Picture', time: '1h' },
        { title: 'Attack Surfaces, Threat Modelling', time: '1h' },
        { title: 'Adversarial Attacks, AI Ethics, Watermarking', time: '1h' },
        { title: 'Machine Learning: Training-Phase Vulnerabilities (Poisoning, Adversarial)', time: '1h' },
        { title: 'Machine Learning: Inference-Phase Vulnerabilities (Model Evasion, Stealing)', time: '1h' },
        { title: 'Malware – Virus, Worm, Ransomware; Zero-day attacks', time: '1h' },
        { title: 'Fuzz testing for malware', time: '1h' },
      ],
    },
    {
      title: 'Day 3: Hardware Security',
      lectures: [
        { title: 'Hardware Security', time: '1h' },
        { title: 'Side-Channel Attacks', time: '1h' },
        { title: 'Fault-Injection Attacks', time: '1h' },
        { title: 'Hardware Trojan', time: '1h' },
        { title: 'Protection Mechanism', time: '1h' },
        { title: 'NICE Lab Visit', time: '2h' },
      ],
    },
    {
      title: 'Day 4: Security Standard & Defences',
      lectures: [
        { title: 'Security Standards', time: '1.5h' },
        { title: 'Microprocessor Security', time: '1.5h' },
        { title: 'Ransomware detection using AI', time: '1.5h' },
        { title: 'Defence Mechanisms', time: '1.5h' },
        { title: 'A look into Security Vulnerabilities at Edge ML devices', time: '1h' },
      ],
    },
    {
      title: 'Day 5: Hardware Security: Demo & Hands-on',
      lectures: [
        { title: 'Timing Attacks: PIN & Password Recovery', time: '1.5h' },
        { title: 'Simple Side-Channel Attacks: Targeting RSA', time: '1.5h' },
        { title: 'Non-Profiled Side-Channel Attacks: Targeting AES', time: '1.5h' },
        { title: 'Demo on Network Scanning Tool/Malware', time: '1.5h' },
      ],
    },
  ],
  faqs: [
    { question: 'Who is this program for?', answer: 'This program is designed for IT professionals, developers, and anyone interested in starting a career in cybersecurity.' },
    { question: 'Are there any prerequisites?', answer: 'A basic understanding of networking and computer systems is recommended but not required.' },
  ],
   reviews: [
    {
      name: 'Jane Doe',
      avatar: '/images/avatar/01.jpg',
      rating: 5,
      time: new Date('2024-05-10'),
      description: 'Excellent course! The hands-on labs were incredibly insightful. Highly recommend for anyone looking to get into cybersecurity.',
    },
    {
      name: 'John Smith',
      avatar: '/images/avatar/02.jpg',
      rating: 4.5,
      time: new Date('2024-05-12'),
      description: 'Very comprehensive content. Dr. Coder explains complex topics in a very understandable way. The section on AI security was fascinating.',
    },
  ]
};

export default cyberSecurityCourse;
